/**
 * A "log message" prefix to help identify the source of the log message
 */
export const LOGGER_PREFIX = '@emarketer/auth :: ';
/**
 * The domain for the authentication-related cookies
 * (should technically be for all cookies on emarketer.com, but some are set to subdomains or www.emarketer.com)
 */
export const COOKIE_DOMAIN = '.emarketer.com';
/**
 * The name of the cookie that need to be cleared when a user's auth status expires
 * `em_uid` is the user ID
 * `em_extid` is the extranet ID
 * `em_sjs` is the "Session Just Started" flag
 *
 * NOTE: we explicitly specify the auth cookie names here as opposed to grabbing all starting with `em_..` because "catch-all" approach may delete `em_..` cookies we actually want to keep, e.g. `em_avc`, or `em_something_else`
 */
export const USER_AUX_INFO_COOKIES = ['em_extid', 'em_sjs', 'em_uid'];

/**
 * Use this for debugging (in `ILoggerDetails.logLevel` property) to log pretty much everything that's happening in this package at each step
 */
export const LOG_LEVEL_DEBUG = 'debug';
/**
 * Public Service Tier (applicable to all public services)
 */
export const SERVICE_TIER_PUBLIC = 'public';
/**
 * Freemium Service Tier (only applicable to Subscription.EA.Freemium)
 */
export const SERVICE_TIER_FREEMIUM = 'freemium';
/**
 * Pro Service Tier (applicable to all PRO services)
 */
export const SERVICE_TIER_PRO = 'pro';
/**
 * [internal use only]
 */
export const SERVICE_TIER_UNKNOWN = `unknown-tier-internal-use-only`;

/**
 * JWT role for PRO users
 */
export const PRO_USER_CORE_ROLE = 'ii_core';

/**
 * The `tiers[]` property of IEmServiceDetails
 */
export type ServiceTier =
  | typeof SERVICE_TIER_PUBLIC
  | typeof SERVICE_TIER_FREEMIUM
  | typeof SERVICE_TIER_PRO
  | typeof SERVICE_TIER_UNKNOWN;

export const ENV_LOCAL = 'local';
export const ENV_DEV = 'development';
export const ENV_STG = 'staging';
export const ENV_PROD = 'production';

/**
 * Cookie name constants for authentication tokens
 */
export const ACCESS_TOKEN_COOKIE_NAME = 'em_at';
export const REFRESH_TOKEN_EXISTS_COOKIE_NAME = 'em_rte';
export const REFRESH_TOKEN_COOKIE_NAME = 'em_rt'; // HttpOnly, server reads this

export type CurrentEnvironment = typeof ENV_LOCAL | typeof ENV_DEV | typeof ENV_STG | typeof ENV_PROD;

export const POD_NA1 = 'na1';
export const POD_NAF = 'naf';

export const LOGIN_TYPE__IP_USER = '2';
